

<template>
  <div class="category_filter_option">
    <div style="
    position: fixed;
    z-index: 99;
    top: 0;
    width: 100%;
    background: #fff;">
      <div class="choose_header">
        <span class="back">
          <i class="material-icons" @click="goBack()">keyboard_backspace</i>
          {{ $t("filter") }}
        </span>
        <!-- <span @click="clearFilter">{{ $t("clearFilter") }}</span> -->
      </div>
      <div class="filter_list">
        <div class="cat_wrap">
          <ul class="category_tab" v-if="filterOptionList">
              <!-- <li
                :key="0"
                :class="{ active: filterIndex == 0 }"
                >
                <span @click="getFilterItem(0)">{{this.$t("price")}}</span>
            </li> -->
            <li
              v-for="(filterItem, index) in filterOptionList"
              :key="index"
              :class="{ active: index == filterIndex }"
            >
              <span @click="getFilterItem(index)">{{ filterItem.displayName }} <strong v-if="parseFloat(filterItem.selectedFacetCount)>0">({{filterItem.selectedFacetCount}})</strong></span>
            </li>
          </ul>
          <div class="rght_tab">
            <!-- <div class="cata_row" v-show="filterIndex == 0" style="height: 90vh; overflow-y: scroll;">
              <ul>
                <li
                  class="prod_gallry_col1"
                  v-for="(products, index) in priceFilterDTOs"
                  :class="getSelectedPrice(index)"
                  :key="index"
                >
                  <input
                    type="radio"
                    id="under100"
                    name="drone"
                    value="under100"
                    checked
                  />
                  <label
                    for="under100"
                    @click="
                      choosePrice(products.minPrice, products.maxPrice, index)
                    "
                    ><span></span>{{
                      $t("fromRsTors", {
                        min: products.minPrice,
                        max: products.maxPrice,
                      })
                    }}</label
                  >
                </li>
              </ul>
            </div> -->
            <div class="cata_row" v-for="(products, index) in filterOptionList"
                  :key="index" v-show="filterIndex == index"  style="height: 90vh; overflow-y: scroll;">
              <ul>
                <li class="prod_gallry_col1" v-for="(facetCount, index) in products.facetCounts" 
                :class="{'active' : (checkIndex(products.name,facetCount.name) == 'active'), 'inactive' : (checkIndex(products.name,facetCount.name) != 'active')}">
                  <label>
                    <input
                    type="checkbox"
                    :value="facetCount"
                    @click="selectedFaceCounts(products.name,facetCount.name)"
                  />
                    <span class="checkmark"></span>{{facetCount.displayName }} ({{facetCount.count}})</label>
                </li>
              </ul>
            </div>
            
          </div>
        </div>
      </div>
      <div class="choose_footer" style="justify-content: space-between;">
      <button class="btn_filter blue-blank"  @click="clearFilter()">
          {{ $t("clearFilter") }}
        </button>
        <button class="btn_filter blue" @click="applyFilter()">
          {{ $t("apply") }}
        </button>
        
      </div>
    </div>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchCategoryFilterOption",
  props: {
    dataValue: {
      required: true,
      // type: Array,
    },
    filterOptionList: {
        required: true
    }
  },
  data() {
    return {
      loading: false,
      selectFilterPrice: null,
      minPrice: null,
      maxPrice: null,
      selectedFilterName:"",
      details: [      
      ],
      priceFilterDTOs : [ {
          "minPrice" : "0",
          "maxPrice" : "200",
          "displayName" : null,
          "selected" : false
        }, {
          "minPrice" : "200",
          "maxPrice" : "500",
          "displayName" : null,
          "selected" : false
        }, {
          "minPrice" : "500",
          "maxPrice" : "1000",
          "displayName" : null,
          "selected" : false
        }, {
          "minPrice" : "1000",
          "maxPrice" : "2000",
          "displayName" : null,
          "selected" : false
        }, {
          "minPrice" : "2000",
          "maxPrice" : "10000000",
          "displayName" : null,
          "selected" : false
        } ],
      filterOption: [this.$t("price")],
      filterIndex: 0,
      showFilterItem: true,
      checkedFilterIds:[],
      itemFacetFields: []
    };
  },
  watch: {
    dataValue() {
      this.details = this.dataValue;
    },
  },
  methods: {
      setBlankFaceList(){
          this.itemFacetFields = []
      },
      selectedFaceCounts(name,faceCount){
        this.selectedFilterName = faceCount
        const index = this.itemFacetFields.findIndex(obj => obj.name === name);
        if(index >= 0) {
            const nameExists = this.itemFacetFields[index].facetCounts
                                .findIndex(item =>  item.name === faceCount)
            if(nameExists > -1){ 
                if(this.itemFacetFields[index].facetCounts.length > 1){
                    this.itemFacetFields[index].facetCounts.splice(nameExists,1)
                }else{
                    this.itemFacetFields.splice(index,1)
                }
                
            }
            else this.itemFacetFields[index].facetCounts.push({'name':faceCount});
        }
        else this.itemFacetFields.push({name:name, facetCounts: [{name:faceCount}]})
      },
      checkIndex(name,faceCount){
          const index = this.itemFacetFields.findIndex(obj => obj.name === name);
          if(index>=0){
              const nameExists = this.itemFacetFields[index].facetCounts
                                .findIndex(item =>  item.name === faceCount)
            if (nameExists > -1) {
            return "active";
            } else {
            return "inactive";
            }
        } 
      },
    getFilterItem(index) {
      this.filterIndex = index;
    },
    getSelectedPrice(selectFilterPrice) {
      if (this.selectFilterPrice == selectFilterPrice) {
        return "choosed_option";
      }
    },
    choosePrice(min, max, selectFilterPrice) {
      if (parseInt(this.selectFilterPrice) === parseInt(selectFilterPrice)) {
        return;
      }
      this.selectFilterPrice = selectFilterPrice;
      this.minPrice = min;
      this.maxPrice = max;
    },
    goBack() {
      this.$emit("closeAllCatFromHeader");
    },
    applyFilter() {
      if (this.itemFacetFields.length || this.minPrice || this.maxPrice) {
        this.$emit("getFilterList", this.minPrice , this.maxPrice, this.itemFacetFields);
        this.$emit("getFilterClear", true);
      } else {
        this.$emit("closeAllCat");
        this.$emit("getFilterClear", false);
      }
      this.getFilterItem(0)
    },
    clearFilter() {
        this.loading = true
      this.itemFacetFields = [],
        this.minPrice = null,
        this.maxPrice = null,
        this.selectFilterPrice = null;
        this.checkIndex()
        this.loading = false
    },
    getMinPrice(value) {
      this.minPrice = value;
    },
    getMaxPrice(value) {
      this.maxPrice = value;
    },
  },
  mounted() {
    this.details = this.dataValue;
  },
};
</script>
